import React, { Suspense, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { useSystemTheme } from "@/hooks/useSystemTheme";
import { useAppStore, useDarkMode } from "@/store/appStore";

const FizurPage = React.lazy(() => import("@/components/pages/business/FizurPage"));

/**
 * Оболочка поддомена fizur.*: тот же тёмный topbar и полотно, что у кабинета,
 * но без бокового меню — на поддомене одна страница. Страница публичная:
 * вход не нужен, выгрузки адресуются случайным идентификатором.
 */
const FizurShell: React.FC = () => {
  const darkMode = useDarkMode();
  const setDarkMode = useAppStore((state) => state.setDarkMode);
  const themePreference = useAppStore((state) => state.themePreference);
  const systemThemeIsDark = useSystemTheme();

  useEffect(() => {
    setDarkMode(themePreference === "system" ? systemThemeIsDark : themePreference === "dark");
  }, [systemThemeIsDark, themePreference, setDarkMode]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);

  useEffect(() => {
    document.title = "Физюр · Контекст";
  }, []);

  return (
    <div className="min-h-screen w-full bg-surface-topbar">
      <header className="fixed left-0 right-0 top-0 z-30 h-[52px] border-b border-white/[0.06] bg-surface-topbar text-top-ink-1">
        <div className="flex h-full items-center gap-3 px-4">
          <div className="flex items-baseline gap-2.5">
            <span className="font-display text-fs-lg font-bold uppercase tracking-[0.02em] text-accent">Контекст</span>
            <span className="font-mono text-fs-2xs uppercase tracking-[0.14em] text-top-ink-3">Физюр</span>
          </div>
        </div>
      </header>

      <main className="min-h-screen pt-[52px] text-ink-1">
        <div className="min-h-[calc(100vh-52px)] bg-surface-canvas lg:rounded-t-panel">
          <div className="mx-auto max-w-5xl px-4 pb-12 pt-8 sm:px-8">
            <Suspense
              fallback={
                <div className="flex justify-center py-20">
                  <LoadingSpinner size="lg" />
                </div>
              }
            >
              <FizurPage />
            </Suspense>
          </div>
        </div>
      </main>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "rgb(var(--c-elevated))",
            color: "rgb(var(--c-ink-1))",
            border: "1px solid rgb(var(--c-border))",
            borderRadius: "10px",
            fontSize: "13px",
          },
        }}
      />
    </div>
  );
};

export default FizurShell;
